import React from 'react';
import SectionWrapper from 'Components/SectionWrapper/SectionWrapper.js';

const Ausbildung = () =>
      <div>
        <SectionWrapper title="Ausbildung">
        <div>
          <p>1. Weiterbildung im Fachgebiet Angiologie für 18 Monate.<br />Die Ermächtigung hierfür hat Frau Dr. Grahl von der Ärztekammer Niedersachsen erhalten.<br />
          <br />2. Ausbildung zur medizinischen Fachangestellten (w/m/d)<br />Bei Interesse kontaktieren Sie uns bitte direkt.</p>
        </div>
        </SectionWrapper>
    </div>
export default Ausbildung;
